var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FormEditor } from "@/components/forms/components/formEditor";
export var LayoutDetail = function (_a) {
    var layoutName = _a.layoutName, packageName = _a.packageName, moduleName = _a.moduleName;
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "" }, { children: _jsx(FormEditor, { moduleName: moduleName, packageName: packageName, layoutName: layoutName }) })) }));
};
